import { Alert, Box, Button, Snackbar, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { startBankTransferPayment } from '../../api/bankTransfer';
import { startBarionPayment } from '../../api/barion';
import { checkoutOrder, getOrderInformation } from '../../api/subscriptions';

import OrderHeader from '../../components/order/orderHeader';
import OrderInvoiceData from '../../components/order/orderInvoiceData';
import PaymentInfo from '../../components/order/PaymentInfo';

const OrderForm = () => {
  const navigate = useNavigate();
  const [partnerData, setPartner] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [couponCode, setCoupon] = useState('');
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: 'info',
    message: '',
  });

  let orderData = {};
  if (localStorage.orderItem) {
    orderData = JSON.parse(localStorage.orderItem);
  }

  const handleCouponChange = (e) => {
    setCoupon(e.target.value);
  };

  const handleDataChange = (returnData) => {
    setPartner(returnData);
    setPaymentMethod(returnData.paymentMethod);
  };

  const cancelPayment = () => {
    partnerData.paymentMethod = '';
    setPaymentMethod('');
  };

  const proceedCheckout = () => {
    const checkoutData = {
      userId: partnerData.userId,
      subscription_code: orderData.subscription_code,
      subscriptionPriceId: orderData.subscription_price_id,
      subscription_days: orderData.valid_days,
      subscription_price: orderData.price,
      PaymentCurrency: 'HUF',
      PaymentMethod: partnerData.paymentMethod,
      PaymentStatus: 'OPEN',
      coupon_code: couponCode,
      BarionRecurrenceId: `${partnerData.userId}-${orderData.subscription_code}-${orderData.valid_days}-${partnerData.lastName}-${partnerData.firstName}`,
    };

    checkoutOrder(checkoutData).then((result) => {
      if (result.isOk) {
        if (partnerData.paymentMethod === 'BANK_CARD') {
          startBarionPayment(result.data.data)
            .then((barionStart) => {
              if (barionStart.isOk) {
                navigate(`/checkout?orderId=${result.data.data.id}`, {
                  state: { orderId: result.data.data.id },
                });
              } else {
                showErrorToast(
                  'Hiba a feldolgozás során kérem ismételje meg újra!'
                );
              }
            })
            .catch((err) => {
              showErrorToast(err);
            });
        } else {
          getOrderInformation(result.data.data.id).then(
            (orderDataforCheckout) => {
              startBankTransferPayment(orderDataforCheckout.data).then(
                (invoice) => {
                  if (invoice.isOk) {
                    navigate(`/checkout?orderId=${result.data.data.id}`, {
                      state: { orderId: result.data.data.id },
                    });
                  } else {
                    showErrorToast(
                      'Hiba a feldolgozás során kérem ismételje meg újra!'
                    );
                  }
                }
              );
            }
          );
        }
      } else {
        showErrorToast('Hiba a feldolgozás során kérem ismételje meg újra!');
      }
    });
  };

  const showErrorToast = (message) => {
    setToastConfig({ isVisible: true, type: 'error', message });
  };

  const handleToastClose = () => {
    setToastConfig({ ...toastConfig, isVisible: false });
  };

  useEffect(() => {
    if (!localStorage.orderItem) {
      navigate('/home');
    }
  }, [paymentMethod]);

  return (
    <Box
      maxWidth='lg'
      sx={{
        width: '100%', // A kis képernyőkön ne legyen probléma
        margin: '0 auto', // Középre igazítja az egész tartalmat
        p: 4, // Egy kicsit csökkentett padding
      }}
    >
      <Typography variant='h4' gutterBottom textAlign={'center'}>
        Előfizetés megrendelése
      </Typography>

      <Snackbar
        open={toastConfig.isVisible}
        autoHideDuration={3000}
        onClose={handleToastClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleToastClose}
          severity={toastConfig.type}
          sx={{ width: '100%' }}
        >
          {toastConfig.message}
        </Alert>
      </Snackbar>

      {paymentMethod === '' && localStorage.orderItem && (
        <>
          <OrderHeader item={orderData} />
          <OrderInvoiceData
            itemData={orderData}
            handleCallback={handleDataChange}
          />
        </>
      )}

      {paymentMethod !== '' && (
        <>
          <OrderHeader item={orderData} />
          {/*partnerData.paymentMethod === 'BANK_CARD' && (
            <Box className='couponBox'>
              <Box className='coupon-code'>
                <Typography variant='body2'>
                  Amennyiben van kuponod itt megadhatod:
                </Typography>
                <TextField
                  fullWidth
                  variant='outlined'
                  placeholder='Kupon kód'
                  value={couponCode}
                  onChange={handleCouponChange}
                  margin='dense'
                />
                {couponCode === 'KUPON_NINCS_MOST' && (
                  <Typography color='green'>
                    Érvényes kupon! Egy hetes ingyenes előfizetés
                  </Typography>
                )}
              </Box>
            </Box>
          )*/}

          <PaymentInfo paymentMethod={partnerData.paymentMethod} />

          {partnerData.paymentMethod === 'BANK_CARD' && (
            <Box
              className='payment-logo-order-form'
              sx={{ textAlign: 'center', mt: 2 }}
            >
              <img
                src={
                  process.env.PUBLIC_URL +
                  '/img/barion-card-strip-intl__medium.png'
                }
                alt='Logo'
              />
            </Box>
          )}

          <Box
            className='payment-order-buttons'
            sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}
          >
            <Button variant='outlined' color='error' onClick={cancelPayment}>
              Előfizetés megszakítása
            </Button>
            <Button
              variant='contained'
              color='success'
              onClick={proceedCheckout}
            >
              Előfizetés megerősítése
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export default OrderForm;
